import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { AuthenticationReducerType } from "./types";

const authenticationReducer = (state: RootState): AuthenticationReducerType => state.authentication;

export const TipoProfiloSede = "Sede";

export const accessTokenAdminSelector = createSelector(
  authenticationReducer,
  (state: AuthenticationReducerType) => state.accessToken
);

export const userInfoSelector = createSelector(
  authenticationReducer,
  (state: AuthenticationReducerType) => state.userInfo
);

export const isTipoProfiloSedeSelector = createSelector(
  authenticationReducer,
  (state: AuthenticationReducerType) => state.userInfo?.tipoProfilo === TipoProfiloSede
)